import m from "../../geodata/es2015/latviaLow";
window.am4geodata_latviaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/latviaLow.js
// module id = null
// module chunks = 